import { useState } from "react";
import API from "../services/api";
import { useNavigate } from "react-router-dom";

function Address() {

    const [addressLine, setAddressLine] = useState("")
    const [city, setCity] = useState("")
    const [state, setState] = useState("")
    const [pincode, setPincode] = useState("")
    const [country, setCountry] = useState("")
    const [street, setStreet] = useState("")

    const navigate = useNavigate();

    const handleAddressRegister = async (e) => {
        e.preventDefault();

        try {
            await API.post("/api/address", {
                addressLine,
                street,
                city,
                state,
                country,
                pincode
            })

            alert("Address Saved Successfully")
            navigate("/")
        } catch (error) {
            alert("Address Not Saved")
            console.log(error)
        }
    }

    return (
        <div className="container d-flex justify-content-center mt-5">
            <div
                className="card shadow p-4"
                style={{ width: "450px", borderRadius: "10px" }}
            >
                <h4 className="mb-3 fw-bold">Add Delivery Address</h4>

                <form onSubmit={handleAddressRegister}>

                    <div className="mb-3">
                        <label className="form-label">Address Line</label>
                        <textarea
                            placeholder="House no, Building, Area"
                            onChange={(e) => setAddressLine(e.target.value)}
                            className="form-control"
                            rows="2"
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <label className="form-label">Street</label>
                        <input
                            type="text"
                            placeholder="Street name"
                            onChange={(e) => setStreet(e.target.value)}
                            className="form-control"
                            required
                        />
                    </div>

                    <div className="row">
                        <div className="col-md-6 mb-3">
                            <label className="form-label">City</label>
                            <input
                                type="text"
                                placeholder="City"
                                onChange={(e) => setCity(e.target.value)}
                                className="form-control"
                                required
                            />
                        </div>

                        <div className="col-md-6 mb-3">
                            <label className="form-label">Pincode</label>
                            <input
                                type="text"
                                placeholder="Pincode"
                                onChange={(e) => setPincode(e.target.value)}
                                className="form-control"
                                required
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6 mb-3">
                            <label className="form-label">State</label>
                            <input
                                type="text"
                                placeholder="State"
                                onChange={(e) => setState(e.target.value)}
                                className="form-control"
                                required
                            />
                        </div>

                        <div className="col-md-6 mb-3">
                            <label className="form-label">Country</label>
                            <input
                                type="text"
                                placeholder="Country"
                                onChange={(e) => setCountry(e.target.value)}
                                className="form-control"
                                required
                            />
                        </div>
                    </div>

                    <button
                        className="btn w-100 mt-3"
                        style={{
                            backgroundColor: "#FFD814",
                            border: "none",
                            fontWeight: "bold"
                        }}
                    >
                        Save Address
                    </button>
                </form>
            </div>
        </div>
    );
}

export default Address;